module.exports = __webpack_public_path__ + "static/media/Group 9964.6aa09a4c.svg";